import React from "react";
import { Gpt } from "../base/Gpt";
import { FILM_CONFIG } from "./filmConfig";

export default function FilmGpt(props) {
  return (
    <Gpt
      {...props}
      workshopConfig={FILM_CONFIG.gpt}
      storageKey={FILM_CONFIG.storageKeys.gptMessages}
    />
  );
}
